<template>
<div>
  <highcharts ref="gaugeChart" :options="options"></highcharts>
</div>
</template>

<script>
// import moment from 'moment-timezone'

export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    scale: {
      type: String
    },
    value: {
      type: Number
    },
    labels: {
      type: Array
    },
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: 500
    }
  },
  watch: {
    value () {
      this.options.series[0].data = [this.value]
    }
  },
  data () {
    return {
      options: {
        chart: {
          type: 'solidgauge',
          height: '90%',
          spacingTop: 5,
          spacingLeft: 0,
          spacingRight: 0,
          spacingBottom: 10
        },
        title: null,
        pane: {
          center: ['50%', '50%'],
          size: '100%',
          startAngle: -90,
          endAngle: 90,
          background: {
            backgroundColor: '#EEE',
            innerRadius: '70%',
            outerRadius: '100%',
            shape: 'arc'
          }
        },
        yAxis: {
          min: this.minValue,
          max: this.maxValue,
          lineColor: '#8D8D8D',
          tickColor: '#8D8D8D',
          intervalWidth: 2,
          zIndex: 4,
          minorTickInterval: null,
          tickInterval: 50,
          labels: {
            step: 20,
            y: 16
          },
          title: {
            style: {
              display: 'none'
            }
          },
          stops: [
            [0, '#4673ac'], // blue
            [0.2, '#79c04f'], // green
            [0.4, '#ffcc00'], // yellow
            [0.6, '#ff6600'], // orange
            [0.8, '#ff5050'], // red
            [1.0, '#cc0000']
          ]
        },
        plotOptions: {
          solidgauge: {
            innerRadius: '70%',
            dataLabels: {
              y: -55,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        series: [{
          data: [this.value],
          dataLabels: {
            format: '<div style="text-align:center"><span style="font-size:1.5rem;color:black">{y}</span><br/>' +
              '<span style="font-size:0.8rem;color:silver">' + this.scale + '</span></div>'
          }
        }]
      }
    }
  }
}
</script>

<style scoped></style>
